import { Component, LOCALE_ID } from '@angular/core';
import { ActivatedRoute, RouterLink } from "@angular/router";
import { JsonPipe, NgIf } from "@angular/common";
import { ClrIconModule } from "@clr/angular";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";
import { ConfirmationFormComponent } from "../confirmation-form/confirmation-form.component";
import { Confirmations } from "../../../_shared/interfaces";
import { AlertService, ConfirmationStoreService, IAlertType } from "../../../_shared/services";

import { environment as env } from '../../../../environments/environment';

@Component({
  selector: 'app-confirmation-update',
  standalone: true,
  imports: [
    ConfirmationFormComponent,
    ClrIconModule,
    RouterLink,
    NgIf,
    JsonPipe
  ],
  templateUrl: './confirmation-update.component.html',
  styleUrl: './confirmation-update.component.sass',
  providers: [{ provide: LOCALE_ID, useValue: 'de' }]
})
export class ConfirmationUpdateComponent {
  projectId: string = '';
  confirmationId: number = 0;
  jobId: number = 0;
  confirmations: Confirmations[] = [];
  devMode: boolean;

  constructor(
    private confss: ConfirmationStoreService,
    private alertDispatcher: AlertService,
    private route: ActivatedRoute
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
    this.devMode = env.stages.dev;
  }

  ngOnInit() {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('projid') ?? '';
    this.jobId = parseInt(params.get('jobid') ?? '0', 10);
    this.confirmationId = parseInt(params.get('confid') ?? '0', 10);
    this.loadConfirmation(this.projectId, this.jobId, this.confirmationId);
  }

  loadConfirmation(projectId: string, jobId: number, confirmationId: number) {
    this.confss.getConfirmation(projectId, jobId, confirmationId).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Confirmationdaten gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        this.confirmations = data.object;
      },
      complete: () => {},
      error: () => {
        return;
      }
    });
  }
}
